import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.167 10.683c.676.677 1.833.198 1.833-.759v-3.85C19 5.48 18.52 5 17.926 5h-3.85c-.957 0-1.436 1.157-.76 1.833z"
    }, null, -1)
  ])))
}
export default { render: render }